import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const SiteFilesNewDnDTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.folder-title" />;
